/* Wearable Co. — product page V2 behaviour.
   Reads its config from #wco-pdp-data (rendered by sections/custom-product-main.liquid).
   Size is never preselected; ?variant= sets colour only. After a successful add it fires a
   cancelable `wearableco:product-added` event and, unless cancelled, goes to the cart page. */
(function () {
  'use strict';

  var root = document.querySelector('[data-wco-pdp]');
  var dataEl = document.getElementById('wco-pdp-data');
  if (!root || !dataEl) return;

  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var variants = cfg.variants || [];
  var CI = cfg.colorIndex;
  var SI = cfg.sizeIndex;
  var T = cfg.text || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mq = window.matchMedia('(max-width: 860px)');

  var form = document.getElementById('wco-product-form');
  var idInput = document.getElementById('wco-variant-id');
  var atc = document.getElementById('wco-atc');
  var atcLabel = document.getElementById('wco-atc-label');
  var atcError = document.getElementById('wco-atc-error');
  var sizeGroup = document.getElementById('wco-size-group');
  var sizeLabel = document.getElementById('wco-size-label-text');
  var sizeMsg = document.getElementById('wco-size-msg');
  var colorValue = document.getElementById('wco-color-value');
  var priceEl = document.getElementById('wco-price');
  var compareEl = document.getElementById('wco-compare');
  var mainImg = document.getElementById('wco-main-img');
  var noPhoto = document.getElementById('wco-nophoto');
  var noPhotoName = document.getElementById('wco-nophoto-name');
  var strip = root.querySelector('.wco-thumbs');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('.wco-thumb'));
  var swWrap = document.getElementById('wco-swatches');
  var moreBtn = document.getElementById('wco-more');
  var sticky = document.getElementById('wco-sticky');
  var stickyMeta = document.getElementById('wco-sticky-meta');
  var stickyBtn = document.getElementById('wco-sticky-btn');

  function byId(id) {
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return null;
  }

  var initial = byId(cfg.initialVariant) || variants[0];
  if (!initial || !form || !atc) return;

  var sel = initial.options.slice();
  if (SI > -1) sel[SI] = null;
  var busy = false;
  var swatchesTouched = false;

  /* ---------- variant lookups ---------- */

  function matches(v, s, skip) {
    for (var i = 0; i < s.length; i++) {
      if (i === skip || s[i] === null) continue;
      if (v.options[i] !== s[i]) return false;
    }
    return true;
  }

  function exact() {
    if (sel.indexOf(null) > -1) return null;
    for (var i = 0; i < variants.length; i++) if (matches(variants[i], sel, -1)) return variants[i];
    return null;
  }

  function partial() {
    var first = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!matches(v, sel, SI)) continue;
      if (v.available) return v;
      if (!first) first = v;
    }
    return first;
  }

  function anyAvailable() {
    return variants.some(function (v) { return v.available && matches(v, sel, SI); });
  }

  function sizeState(value) {
    var s = sel.slice();
    s[SI] = value;
    var st = { exists: false, avail: false };
    variants.forEach(function (v) {
      if (!matches(v, s, -1)) return;
      st.exists = true;
      if (v.available) st.avail = true;
    });
    return st;
  }

  function colourMedia(colour) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options[CI] === colour && v.media) return v.media;
    }
    return null;
  }

  /* ---------- formatting ---------- */

  function group(n, dec, th, dp) {
    var p = n.toFixed(dec).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
    return p.join(dp);
  }

  function money(cents) {
    var f = cfg.moneyFormat || '${{amount}}';
    var n = cents / 100;
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return group(Math.round(n), 0, ',', '.');
        case 'amount_with_comma_separator': return group(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(Math.round(n), 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(n, 2, "'", '.');
        default: return group(n, 2, ',', '.');
      }
    });
  }

  function fmtDate(d) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  }

  function ymd(d) {
    function p(x) { return (x < 10 ? '0' : '') + x; }
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
  }

  function parseYmd(s) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(s || '')) return null;
    var p = s.split('-');
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }

  function addBusinessDays(from, n) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n--;
    }
    return d;
  }

  /* ---------- gallery ---------- */

  function setActiveThumb(mediaId) {
    var active = null;
    thumbs.forEach(function (t) {
      var on = mediaId !== null && String(t.getAttribute('data-media-id')) === String(mediaId);
      t.classList.toggle('is-active', on);
      if (on) { t.setAttribute('aria-current', 'true'); active = t; }
      else t.removeAttribute('aria-current');
    });
    if (active && strip) {
      var left = active.offsetLeft - strip.clientWidth / 2 + active.clientWidth / 2;
      strip.scrollLeft = Math.max(0, left);
    }
  }

  function showMedia(mediaId) {
    var m = cfg.media && cfg.media[mediaId];
    if (!mainImg || !m) return false;
    mainImg.srcset = m.srcset;
    mainImg.src = m.src;
    mainImg.alt = m.alt || '';
    mainImg.style.visibility = '';
    if (noPhoto) noPhoto.hidden = true;
    setActiveThumb(mediaId);
    return true;
  }

  function showNoPhoto(colour) {
    if (!noPhoto) return;
    if (noPhotoName) noPhotoName.textContent = colour;
    noPhoto.hidden = false;
    if (mainImg) mainImg.style.visibility = 'hidden';
    setActiveThumb(null);
  }

  function showColour(colour) {
    var id = colourMedia(colour);
    if (id && showMedia(id)) return;
    showNoPhoto(colour);
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { showMedia(t.getAttribute('data-media-id')); });
  });

  /* ---------- messages ---------- */

  function setSizeMsg(text, isError) {
    if (!sizeMsg) return;
    sizeMsg.textContent = text || '';
    sizeMsg.classList.toggle('is-error', !!isError);
    sizeMsg.hidden = !text;
    if (sizeGroup) sizeGroup.classList.toggle('is-invalid', !!isError);
  }

  function showError(text) {
    if (!atcError) return;
    atcError.textContent = text;
    atcError.hidden = false;
  }

  function hideError() {
    if (!atcError) return;
    atcError.textContent = '';
    atcError.hidden = true;
  }

  /* ---------- render ---------- */

  function render() {
    var v = exact();
    var shown = v || partial() || initial;

    if (CI > -1) {
      if (colorValue) colorValue.textContent = sel[CI];
      root.querySelectorAll('.wco-sw').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-value') === sel[CI] ? 'true' : 'false');
      });
    }

    root.querySelectorAll('[data-option-index]').forEach(function (grp) {
      var idx = parseInt(grp.getAttribute('data-option-index'), 10);
      if (idx === CI) return;
      grp.querySelectorAll('.wco-pill').forEach(function (b) {
        var val = b.getAttribute('data-value');
        b.setAttribute('aria-pressed', val === sel[idx] ? 'true' : 'false');
        if (idx === SI) {
          var st = sizeState(val);
          b.disabled = !st.avail;
          b.classList.toggle('is-unavailable', !st.avail);
          b.title = st.avail ? '' : (st.exists ? T.soldOut : T.unavailable);
        }
      });
      var cur = grp.querySelector('[data-selected-value]');
      if (cur) cur.textContent = sel[idx] || '';
    });

    if (SI > -1 && sizeLabel) {
      sizeLabel.textContent = sel[SI] ? (cfg.sizeName + ': ' + sel[SI]) : T.sizePrompt;
    }

    if (priceEl) priceEl.textContent = money(shown.price);
    if (compareEl) {
      if (shown.compare && shown.compare > shown.price) {
        compareEl.textContent = money(shown.compare);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    if (idInput) {
      idInput.value = v ? v.id : '';
      idInput.disabled = !v;
    }

    var needsSize = SI > -1 && sel[SI] === null;
    var state;
    if (needsSize) state = anyAvailable() ? 'ready' : 'soldout';
    else if (!v) state = 'unavailable';
    else state = v.available ? 'ready' : 'soldout';

    if (!busy) {
      atc.disabled = state !== 'ready';
      if (state === 'ready') atcLabel.textContent = T.atc + ' — ' + money(shown.price);
      else if (state === 'soldout') atcLabel.textContent = T.soldOut;
      else atcLabel.textContent = T.unavailable;
    }

    if (stickyMeta) {
      var lead = needsSize ? T.stickyPrompt : (SI > -1 ? cfg.sizeName + ' ' + sel[SI] : '');
      stickyMeta.textContent = (lead ? lead + ' · ' : '') + money(shown.price);
    }
    if (stickyBtn) {
      stickyBtn.disabled = state !== 'ready';
      stickyBtn.textContent = state === 'ready' ? T.atc : (state === 'soldout' ? T.soldOut : T.unavailable);
    }
  }

  function updateUrl() {
    var v = exact() || partial();
    if (!v || !window.history || !window.history.replaceState || !window.URL) return;
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      window.history.replaceState(window.history.state, '', u.toString());
    } catch (e) { /* ignore */ }
  }

  /* ---------- option handlers ---------- */

  function clearSizeIfGone(colourName) {
    if (SI < 0 || sel[SI] === null) { setSizeMsg('', false); return; }
    if (sizeState(sel[SI]).avail) { setSizeMsg('', false); return; }
    var msg = (T.sizeCleared || '').replace('{size}', sel[SI]).replace('{color}', colourName || '');
    sel[SI] = null;
    setSizeMsg(msg, false);
  }

  root.querySelectorAll('.wco-sw').forEach(function (b) {
    b.addEventListener('click', function () {
      var val = b.getAttribute('data-value');
      sel[CI] = val;
      hideError();
      clearSizeIfGone(val);
      showColour(val);
      render();
      updateUrl();
    });
  });

  root.querySelectorAll('[data-option-index]').forEach(function (grp) {
    var idx = parseInt(grp.getAttribute('data-option-index'), 10);
    if (idx === CI) return;
    grp.querySelectorAll('.wco-pill').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        sel[idx] = b.getAttribute('data-value');
        hideError();
        if (idx === SI) setSizeMsg('', false);
        else clearSizeIfGone(sel[CI]);
        render();
        updateUrl();
      });
    });
  });

  /* ---------- swatch overflow ---------- */

  function layoutSwatches() {
    if (!swWrap || !moreBtn) return;
    var sws = swWrap.querySelectorAll('.wco-sw');
    var limit = mq.matches ? cfg.swatchLimitMobile : cfg.swatchLimit;
    var extra = Math.max(0, sws.length - limit);
    var selIdx = -1;
    sws.forEach(function (s, i) {
      s.classList.toggle('is-extra', i >= limit);
      if (s.getAttribute('data-value') === sel[CI]) selIdx = i;
    });
    if (extra === 0) {
      moreBtn.hidden = true;
      swWrap.setAttribute('data-collapsed', 'false');
      return;
    }
    moreBtn.hidden = false;
    if (!swatchesTouched && selIdx >= limit) swWrap.setAttribute('data-collapsed', 'false');
    var expanded = swWrap.getAttribute('data-collapsed') === 'false';
    moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    moreBtn.textContent = expanded ? T.fewer : '+' + extra + ' ' + T.more;
  }

  if (moreBtn && swWrap) {
    moreBtn.addEventListener('click', function () {
      swatchesTouched = true;
      var expanded = swWrap.getAttribute('data-collapsed') === 'false';
      swWrap.setAttribute('data-collapsed', expanded ? 'true' : 'false');
      layoutSwatches();
    });
  }

  /* ---------- add to cart ---------- */

  function validate() {
    if (SI < 0 || sel[SI] !== null) return true;
    setSizeMsg(T.sizeError, true);
    if (sizeGroup) {
      sizeGroup.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      var first = sizeGroup.querySelector('.wco-pill:not([disabled])');
      if (first) first.focus({ preventScroll: true });
    }
    return false;
  }

  function setBusy(on) {
    busy = on;
    atc.setAttribute('aria-busy', on ? 'true' : 'false');
    if (on) {
      atc.disabled = true;
      atcLabel.textContent = T.adding;
      if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.textContent = T.adding; }
    } else {
      render();
    }
  }

  function addToCart() {
    if (busy) return;
    hideError();
    if (!validate()) return;
    var v = exact();
    if (!v || !v.available) { render(); return; }
    setBusy(true);

    fetch(cfg.cartAddUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(
          function (body) { return { ok: r.ok, body: body }; },
          function () { return { ok: r.ok, body: {} }; }
        );
      })
      .then(function (res) {
        if (!res.ok) throw res.body || {};
        var ev = new CustomEvent('wearableco:product-added', {
          bubbles: true,
          cancelable: true,
          detail: { productId: cfg.productId, variant: v, quantity: 1, items: res.body.items || [] }
        });
        var proceed = form.dispatchEvent(ev);
        if (proceed) {
          window.location.href = cfg.cartUrl;
          return;
        }
        setBusy(false);
      })
      .catch(function (err) {
        setBusy(false);
        var extra = err && typeof err.description === 'string' ? ' ' + err.description : '';
        showError(T.atcError + extra);
      });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    addToCart();
  });

  /* ---------- size guide dialog ---------- */

  var dialog = document.getElementById('wco-size-dialog');
  var fitDetails = document.getElementById('wco-fit-details');

  document.querySelectorAll('[data-open-size]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else if (fitDetails) {
        fitDetails.open = true;
        fitDetails.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      }
    });
  });

  if (dialog) {
    dialog.querySelectorAll('[data-close-size]').forEach(function (b) {
      b.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dialog.close();
    });
  }

  var guide = document.getElementById('wco-sizeguide');
  if (guide) {
    var units = Array.prototype.slice.call(document.querySelectorAll('.wco-unit'));
    units.forEach(function (b) {
      b.addEventListener('click', function () {
        units.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        guide.setAttribute('data-show', b.getAttribute('data-unit'));
      });
    });
  }

  /* ---------- delivery + seasonal ---------- */

  var del = document.getElementById('wco-delivery-text');
  if (del && cfg.delivery && cfg.delivery.template) {
    var now = new Date();
    var a = addBusinessDays(now, cfg.delivery.min);
    var b = addBusinessDays(now, cfg.delivery.max);
    del.textContent = cfg.delivery.template.replace('{dates}', fmtDate(a) + ' – ' + fmtDate(b));
  }

  var sea = document.getElementById('wco-seasonal');
  if (sea && cfg.seasonal) {
    var today = ymd(new Date());
    var cut = parseYmd(cfg.seasonal.cutoff);
    var end = cfg.seasonal.end;
    if (cut) {
      if (end && /^\d{4}-\d{2}-\d{2}$/.test(end) && today > end) {
        sea.hidden = true;
      } else if (today <= cfg.seasonal.cutoff) {
        sea.textContent = cfg.seasonal.before.replace('{date}', fmtDate(cut));
        sea.hidden = false;
      } else if (cfg.seasonal.after) {
        sea.textContent = cfg.seasonal.after.replace('{date}', fmtDate(cut));
        sea.hidden = false;
      } else {
        sea.hidden = true;
      }
    }
  }

  /* ---------- sticky mobile bar ---------- */

  var atcAbove = false;
  function syncSticky() {
    if (!sticky) return;
    var show = atcAbove && mq.matches;
    sticky.hidden = !show;
    document.body.classList.toggle('wco-has-sticky', show);
  }

  if (sticky) {
    document.body.appendChild(sticky); // escape .page-wrapper zoom and stacking contexts
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          atcAbove = !en.isIntersecting && en.boundingClientRect.top < 0;
        });
        syncSticky();
      }).observe(atc);
    }
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);
  }

  function onMq() { layoutSwatches(); syncSticky(); }
  if (mq.addEventListener) mq.addEventListener('change', onMq);
  else if (mq.addListener) mq.addListener(onMq);

  /* ---------- init ---------- */

  if (CI > -1 && !colourMedia(sel[CI])) showNoPhoto(sel[CI]);
  layoutSwatches();
  render();
})();
